import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import '../icon/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const documentClickEvent = "ontouchstart" in document.documentElement ? "touchstart" : "click";
let StickyTooltipComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this.handler = null;
  }
  openTooltip() {
    this.handler = this.onDocumentClick.bind(this);
    document.addEventListener(documentClickEvent, this.handler);
    this.isOpen = true;
  }
  closeTooltip() {
    if (this.handler) {
      document.removeEventListener(documentClickEvent, this.handler);
    }
    this.isOpen = false;
  }
  onDocumentClick(event) {
    const targets = event.composedPath ? event.composedPath() : [event.target];
    const isTooltip = targets.some((target) => target === this.$el);
    if (!isTooltip) {
      this.closeTooltip();
    }
  }
};
StickyTooltipComponent = __decorateClass([
  Component({
    name: "ui-sticky-tooltip"
  })
], StickyTooltipComponent);

export default StickyTooltipComponent;
